module.exports = __webpack_public_path__ + "static/img/market04.5a57f677.png";